import React from "react";
import styled from "styled-components";

const Footer = React.memo(({ login }) => {
  const currentYear = new Date().getFullYear();
  return (
    <FooterStyled isLogin={login}>
      <Copyright>
        <b>© {currentYear}</b>
        <span> {process.env.REACT_APP_APP_NAME}.</span>
      </Copyright>
    </FooterStyled>
  );
});
export default Footer;
const FooterStyled = styled.div`
  ${props => {
    let current = props.theme;
    return `
    padding: 0 ${current.gMD};
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height:60px;
    max-height:60px;
    height:60px;
    ${
      props.isLogin
        ? `
      flex-direction: column;
      text-align: center;
          `
        : `
      flex-direction: row;
      margin-top: auto;
      border-top:1px solid rgba(${current.black}, 0.0625);
      background:rgb(${current.white});
      `
    }`;
  }}
`;
const Copyright = styled.div`
  ${props => {
    let current = props.theme;
    return `
        ${current.secondaryFont};
        ${current.fSM};
        > b {
            font-weight: normal;
            color: rgb(${current.black});
            ${current.fSM};
          }
          > span, >a {
            cursor: pointer;
            color: rgb(${current.cOne});
            margin: 0 ${current.gSM};
            :hover{
              color: rgba(${current.black},0.8);
            }
          }
    `;
  }}
`;
